import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api') + '/partner';

export const getPartnerBookings = createAsyncThunk('booking/getAll', async ({ userId, params }) => {
  const r = await axios.get(`${API}/bookings/${userId}`, { params }); return r.data;
});
export const cancelBookingByPartner = createAsyncThunk('booking/cancel', async ({ userId, bookingId, reason }) => {
  const r = await axios.post(`${API}/bookings/${userId}/${bookingId}/cancel`, { reason }); return r.data;
});

const bookingSlice = createSlice({
  name: 'booking',
  initialState: { bookings: [], pagination: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartnerBookings.pending, (s) => { s.loading = true; })
      .addCase(getPartnerBookings.fulfilled, (s, a) => {
        s.loading = false; s.bookings = a.payload.bookings; s.pagination = a.payload.pagination;
      })
      .addCase(getPartnerBookings.rejected, (s) => { s.loading = false; })
      .addCase(cancelBookingByPartner.fulfilled, (s, a) => {
        const idx = s.bookings.findIndex(b => b._id === a.payload.booking._id);
        if (idx >= 0) s.bookings[idx] = a.payload.booking;
      });
  }
});

export default bookingSlice.reducer;
